import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { TriOptionsModel } from '../../../../../../../FrontDeskModule/Shared/components/FrontDeskToolbar';
import { ArrivalReportFormModel, ArrivalReportStateEnum } from '../../models';

export const getDefaultValues = (globalSettings: GlobalSettingsModel): ArrivalReportFormModel => ({
  from: globalSettings?.frontend_date,
  to: globalSettings?.frontend_date,
  card_ids: [],
  rate_ids: [],
  room_type_ids: [],
  price: false,
  states: [ArrivalReportStateEnum.ARRIVAL],
  nationality_ids: null,
  file_type: 'pdf',
  sortBy: TriOptionsModel.arrival_date,
  sortDirection: 'asc',
  grouped: true,
  exclude_partial: false,
});
